var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget-wrapper',{staticClass:"js_year_graph",attrs:{"loader":_vm.api,"title":_vm.title,"draggable":false}},[_c('graph-container',{attrs:{"datasets":_vm.lines},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('year-graph',{attrs:{"lines":scope.datasets,"height":200,"label-xaxis":_vm.labels.xAxis,"label-yaxis":_vm.labels.yAxis}})]}}])}),_vm._v(" "),_c('year-table',{attrs:{"rows":_vm.rows}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eec003a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/year-graph/YearGraphWidget.vue
// module id = 852
// module chunks = 1